import { Dialog } from "../../components/Dialog";
import { SHORTCUT_HELP } from "./useMailShortcuts";

// 快捷鍵說明(按 `?` 打開)。對話框開著時其他快捷鍵不作用(見 useMailShortcuts)。

export function ShortcutHelp({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Dialog open={open} onClose={onClose} title="快捷鍵" maxWidth="max-w-sm">
      <dl className="m-0 grid grid-cols-[auto_1fr] gap-x-4 gap-y-1.5 text-sm">
        {SHORTCUT_HELP.map(([keys, text]) => (
          <div key={keys} className="contents">
            <dt>
              <kbd className="rounded border border-[var(--border-strong)] bg-[var(--surface-2)] px-1.5 py-0.5 font-mono text-xs text-[var(--text)]">
                {keys}
              </kbd>
            </dt>
            <dd className="m-0 text-[var(--text-2)]">{text}</dd>
          </div>
        ))}
      </dl>
      <p className="m-0 mt-3 text-xs text-[var(--text-3)]">在輸入框裡打字時快捷鍵不作用。</p>
    </Dialog>
  );
}
